import { type FC } from "react";
import { useTranslation } from "react-i18next";
import countryConfig from "$/open_dict/country.json";
import { CountryIcon } from "./CountryIcon";
import { I18nNamespace } from "@/const/i18nNamespace";
import { CheckTag } from "./CheckTag";
import { CountryListItem } from "./CountryListItem";

export type ConfigKey = keyof typeof countryConfig;

const HotCountry: ConfigKey[] = ["chn", "twn", "hkg", "usa", "jpn", "kor"];

export const CountryList: FC<{
  data: Array<{
    label: string;
    value: ConfigKey[];
  }>;
  showTelCode?: boolean;
  value?: ConfigKey | "";
  onChange: (code: ConfigKey) => void;
}> = ({ data, showTelCode, value, onChange }) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="mb-3 px-6">
        {showTelCode ? t("hot_areacode") : t("hot_country")}
      </div>
      <div className="mb-2 grid grid-cols-2 gap-3 px-6">
        {HotCountry.map((code) => (
          <CheckTag
            key={code}
            className="h-9 justify-start gap-2 px-2"
            onClick={() => onChange(code)}
            isActived={value === code}
          >
            {showTelCode ? (
              <div className="flex items-center gap-1 text-sm">
                <div className="w-12 pl-1 text-left">
                  {countryConfig[code].extra.tel}
                </div>
                <div className="min-w-0 flex-1 shrink-0 truncate text-left leading-4">
                  {t(`${I18nNamespace.COUNTRY}:${code}`)}
                </div>
              </div>
            ) : (
              <>
                <CountryIcon
                  code={countryConfig[code].extra.flag}
                  className="text-shadow-sm text-2xl"
                />
                <div className="flex min-w-0 items-center gap-1 text-sm">
                  <div className="min-w-0 flex-1 shrink-0 truncate text-left leading-4">
                    {t(`${I18nNamespace.COUNTRY}:${code}`)}
                  </div>
                </div>
              </>
            )}
          </CheckTag>
        ))}
      </div>
      {data.map((item) => (
        <div key={item.label}>
          <div className="px-6 pt-2">{item.label}</div>
          {item.value.map((code) => (
            <CountryListItem
              key={code}
              code={code}
              showTelCode={showTelCode}
              isActived={value === code}
              autoScrollIntoView={!HotCountry.includes(code)}
              onChange={onChange}
            />
          ))}
        </div>
      ))}
    </div>
  );
};
